import router from "@/router";
import store from "@/store";
import { computed, watch } from "vue";
import { useDisplay } from "vuetify";

const DRAWER_WIDTH_KEY = "pcse_drawer_width";
const MIN_WIDTH = 210;
const MAX_WIDTH = 400;

export default {
  name: "Navigation",

  data: () => ({
    drawerWidth: parseInt(localStorage.getItem(DRAWER_WIDTH_KEY) || "256"),
    isResizing: false,
    showLogoutConfirm: false,
    pessoal: [
      ["Dados", "/Usuario/DadosPessoais", "mdi-account-details"],
      ["Segurança", "/Usuario/Seguranca", "mdi-account-lock"],
    ],
    tbl: [
      ["Criar", "/Questionario/Criar", "mdi-text-box-plus"],
      ["Listar", "/Questionarios/Listar", "mdi-list-box"],
      ["Aplicar", "/Prova/Aplicar", "mdi-note"],
      ["Dashboard Turma", "/Provas/Listar", "mdi-view-dashboard"],
      ["Dashboard Individual", "/Provas/DashboardIndividual", "mdi-chart-box-outline"],
      ["Repositório", "/Repositorios/Listar", "mdi-folder-question"],
    ],
    avaliacaoDiscursivaProf: [
      [
        "Adicionar Avaliação",
        "/AvaliacaoDiscursiva/Professor",
        "mdi-text-box-edit",
      ],
      [
        "Consultar protocolo",
        "/AvaliacaoDiscursiva/ConsultarProtocolo",
        "mdi-magnify",
      ],
      ["Admin", "/AvaliacaoDiscursiva/Admin", "mdi-shield-account"],
    ],
    avaliacaoDiscursivaAluno: [
      ["Aluno", "/AvaliacaoDiscursiva/Aluno", "mdi-pencil"],
      [
        "Consulta prova",
        "/AvaliacaoDiscursiva/ConsultaProva",
        "mdi-clipboard-check",
      ],
    ],
    osceProf: [
      ["4o. ao 8o. Períodos", "/OSCE/Formulario", "mdi-clipboard-edit"],
      ["9o. ao 12o. Períodos", "/OSCE/9o-12o", "mdi-clipboard-text"],
      ["Histórico", "/OSCE/Historico", "mdi-history"],
    ],
    osceAluno: [
      ["OSCE", "/OSCE/Aluno", "mdi-clipboard-check"],
    ],
    estatisticaTurmaProf: [
      ["Geral", "/AvaliacaoDiscursiva/EstatisticaTurma/Geral", "mdi-chart-box"],
      [
        "Individual",
        "/AvaliacaoDiscursiva/EstatisticaTurma/Individual",
        "mdi-account-group",
      ],
    ],
    salaAula: [
      ["Entrar", "/Aluno/Prova", "mdi-login"],
      ["Dashboard TBL", "/aProvas/Listar", "mdi-note-text"],
    ],
  }),

  setup() {
    const { mobile } = useDisplay();
    const isMobile = computed(() => mobile.value);

    store.commit("setDrawerState", !mobile.value);

    watch(mobile, (value) => {
      store.commit("setDrawerState", !value);
    });

    return { isMobile };
  },

  computed: {
    tblItems() {
      if (store.state.userType === "coordenador") {
        return [
          ["Dashboard Turma", "/Provas/Listar", "mdi-view-dashboard"],
          ["Dashboard Individual", "/Provas/DashboardIndividual", "mdi-chart-box-outline"],
        ];
      }

      return this.tbl;
    },
    avaliacaoDiscursivaItems() {
      if (store.state.userType === "coordenador") {
        return this.avaliacaoDiscursivaProf.filter(
          ([title]) => title !== "Adicionar Avaliação"
        );
      }

      return this.avaliacaoDiscursivaProf;
    },
    drawerState: {
      get() {
        return store.getters.drawerState;
      },
      set(value) {
        store.commit("setDrawerState", value);
      },
    },
    drawerMode() {
      return this.isMobile ? "temporary" : "permanent";
    },
    drawerWidthValue() {
      return this.isMobile
        ? Math.min(320, window.innerWidth - 32)
        : this.drawerWidth;
    },
  },

  beforeUnmount() {
    document.removeEventListener("mousemove", this._onResize);
    document.removeEventListener("mouseup", this._stopResize);
  },

  methods: {
    closeMobileDrawer() {
      if (this.isMobile) store.commit("setDrawerState", false);
    },

    logout() {
      this.showLogoutConfirm = true;
    },

    confirmLogout() {
      this.showLogoutConfirm = false;
      localStorage.removeItem("token");
      router.push({ name: "login" });
    },

    startResize(e) {
      if (this.isMobile) return;
      e.preventDefault();
      this.isResizing = true;
      document.addEventListener("mousemove", this._onResize);
      document.addEventListener("mouseup", this._stopResize);
    },

    _onResize(e) {
      if (!this.isResizing) return;
      const w = Math.min(Math.max(e.clientX, MIN_WIDTH), MAX_WIDTH);
      this.drawerWidth = w;
    },

    _stopResize() {
      this.isResizing = false;
      localStorage.setItem(DRAWER_WIDTH_KEY, this.drawerWidth);
      document.removeEventListener("mousemove", this._onResize);
      document.removeEventListener("mouseup", this._stopResize);
    },
  },
};
